module.exports = __webpack_public_path__ + "img/background019.044c3124.jpg";